import React from 'react';
import { Link, navigate } from 'gatsby';
import styled from 'styled-components';
import {
  FooterMobileIcon,
  FooterLocationIcon,
  FooterEmailIcon,
  Logo,
  FbIcon,
  IgIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon
} from 'assets/svgs/';

function Footer() {
  return (
    <Container>
      <Sitemap>Sitemap</Sitemap>
      <ContactUs>Contact Us</ContactUs>
      <Home>
        <li>
          <Link to="/">
            <b>Home</b>
          </Link>
        </li>
        <li>
          <Link to="/stairs/">Stairs</Link>
        </li>
        <li>
          <Link to="/doors/">Doors</Link>
        </li>
        <li>
          <Link to="/stair-and-door-parts/">Stair & Door Parts</Link>
        </li>
        <li>
          <Link to="/showcases/">Showcases</Link>
        </li>
        <li>
          <Link to="/about-us/">About Us</Link>
        </li>
        <li>
          <Link to="/trade-partners/">Trade Partners</Link>
        </li>
      </Home>
      <Stairs>
        <li>
          <Link to="/stairs/">
            <b>Stairs</b>
          </Link>
        </li>
        <li>
          <Link to="/stairs/oak/">Oak</Link>
        </li>
        <li>
          <Link to="/stairs/softwood/">Softwood</Link>
        </li>
        <li>
          <Link to="/stairs/walnut/">Walnut</Link>
        </li>
        <li>
          <Link to="/stairs/primed/">Primed</Link>
        </li>
        <li>
          <Link to="/stairs/metal/">Metal</Link>
        </li>
        <li>
          <Link to="/stairs/glass/">Glass</Link>
        </li>
        <li>
          <Link to="/stairs/attic-stairs/">Attic Stairs</Link>
        </li>
      </Stairs>
      <Other style={{ marginTop: '1.7rem' }}>
        <li>
          <b>Other</b>
        </li>
        <li>
          <Link
            to="/guides-and-manuals/"
            onClick={(e) => e.preventDefault()}
            style={{ cursor: 'not-allowed' }}>
            Guides & Manuals
          </Link>
        </li>
      </Other>
      <Doors>
        <li>
          <Link to="/doors/">
            <b>Doors</b>
          </Link>
        </li>
        <li>
          <Link to="/doors/oak/">Oak</Link>
        </li>
        <li>
          <Link to="/doors/classic/">Classic</Link>
        </li>
        <li>
          <Link to="/doors/glazed/">Glazed</Link>
        </li>
        <li>
          <Link to="/doors/grooved/">Grooved</Link>
        </li>
        <li>
          <Link to="/doors/shaker-style/">Shaker Style</Link>
        </li>
        <li>
          <Link to="/doors/fire-doors/">Fire Doors</Link>
        </li>
        <li>
          <Link to="/doors/decorative-panel/">Decorative Panel</Link>
        </li>
        <li>
          <Link to="/doors/masonite-hollow-core/">Masonite Hollow Core</Link>
        </li>
        <li>
          <Link to="/doors/vista/">Vista</Link>
        </li>
      </Doors>
      <DoorsAndStairAndDoorParts style={{ marginTop: '1.7rem' }}>
        <MobileOnly>
          <Link to="/doors/">
            <b>Doors</b>
          </Link>
        </MobileOnly>
        <li>
          <Link to="/stair-and-door-parts/">
            <b>Stair & Door Parts</b>
          </Link>
        </li>
      </DoorsAndStairAndDoorParts>
      <ContactDetails>
        <li>
          <span>
            <FooterEmailIcon width="0.75rem" />
          </span>
          <Link to="/contact-us/">Email Us</Link>
        </li>
        <li>
          <span>
            <FooterMobileIcon width="0.5rem" />
          </span>
          <a href="tel:+35314507826" target="_blank" rel="noreferrer">
            +353-1-4507826
          </a>
        </li>
        {/* <li>
          <span>
            <FooterMobileIcon width="0.5rem" />
          </span>
          <a href="tel:+353877780652" target="_blank" rel="noreferrer">
            +353-87-7780652
          </a>
        </li> */}
        <li>
          <span>
            <FooterLocationIcon width="0.625rem" />
          </span>
          <a href="https://maps.app.goo.gl/LNEQeuDjReMSTn2w9" target="_blank" rel="noreferrer">
            Connolly Stairs and Doors,
            <br />
            Unit 2 Kore Development Park,
            <br />
            JFK Industrial Estate,
            <br />
            Naas Road, Dublin 12
          </a>
        </li>
      </ContactDetails>
      <DesktopSocialIcons>
        <a
          href="https://www.facebook.com/declan.connolly.16/"
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook page">
          <FbIcon />
        </a>
        {/* <TwitterIcon /> */}
        <a
          href="https://www.instagram.com/connollystairs.ie/?hl=en"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram page">
          <IgIcon />
        </a>
        <a
          href="https://ie.linkedin.com/in/declan-connolly-b0068937"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn page">
          <LinkedinIcon />
        </a>
        {/* <WhatsappIcon /> */}
      </DesktopSocialIcons>
      <LogoAndSmallPrint>
        <LogoWrapper to="/" aria-label="Connolly Stairs and Doors homepage">
          <Logo />
        </LogoWrapper>
        <MobileSocialIcons>
          <a
            href="https://www.facebook.com/declan.connolly.16/"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook page">
            <FbIcon />
          </a>
          {/* <TwitterIcon /> */}
          <a
            href="https://www.instagram.com/connollystairs.ie/?hl=en"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram page">
            <IgIcon />
          </a>
          <a
            href="https://ie.linkedin.com/in/declan-connolly-b0068937"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn page">
            <LinkedinIcon />
          </a>
          {/* <WhatsappIcon /> */}
        </MobileSocialIcons>
        <Copyright>© {new Date().getFullYear()} Connolly Stairs. All rights reserved.</Copyright>
        <Links>
          {/* <Link to="/terms-and-conditions/">Terms & Conditions</Link> */}
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/cookie-policy">Cookie Policy</Link>
        </Links>
        <WeMadeThis>
          Website Designed And Developed by{' '}
          <a
            href="https://www.agencyx.ie/"
            rel="noreferrer"
            target="_blank"
            aria-label="Agency X website">
            Agency X
          </a>
          .
        </WeMadeThis>
      </LogoAndSmallPrint>
    </Container>
  );
}

const Container = styled.footer`
  background-color: var(--connolly-grey);
  column-gap: 1.25rem;
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 100px));
  grid-template-rows: repeat(9, auto);
  justify-content: center;
  padding: 3.25rem 0.625rem 0.625rem;

  @media (width >= 768px) {
    grid-template-rows: repeat(4, auto);
    padding: 4rem 0.625rem 1.125rem;
  }

  a {
    color: var(--connolly-black);
  }

  h2 {
    color: var(--connolly-red);
    font-size: 1.125rem;
    margin-bottom: 0.75rem;

    @media (width >= 768px) {
      margin-bottom: 1rem;
    }

    &:nth-of-type(2) {
      margin-top: 3rem;

      @media (width >= 768px) {
        margin-top: initial;
      }
    }
  }

  ul {
    line-height: 1.5rem;
    font-weight: 700;
  }

  li {
    font-weight: 400;
  }
`;

const Sitemap = styled.h2`
  grid-column: 1/3;
  grid-row: 1;

  @media (width >= 900px) {
    grid-column: 2/4;
  }
`;

const Home = styled.ul`
  grid-column: 1/6;
  grid-row: 2;

  @media (width >= 500px) {
    grid-column: 1/3;
  }

  @media (width >= 900px) {
    grid-column: 2/4;
  }
`;

const Stairs = styled.ul`
  grid-column: 7/-1;
  grid-row: 2;

  @media (width >= 500px) {
    grid-column: 4/7;
  }

  @media (width >= 768px) {
    grid-column: 3/5;
  }

  @media (width >= 900px) {
    grid-column: 4/6;
  }
`;

const Doors = styled.ul`
  display: none;

  @media (width >= 500px) {
    display: block;
    grid-column: 7/-1;
    grid-row: 2;
  }

  @media (width >= 768px) {
    grid-column: 5/7;
  }

  @media (width >= 900px) {
    grid-column: 6/8;
  }
`;

const Other = styled.ul`
  grid-column: 1/6;
  grid-row: 3;

  @media (width >= 900px) {
    grid-column: 2/4;
  }
`;

const MobileOnly = styled.li`
  @media (width >= 500px) {
    display: none;
  }
`;

const DoorsAndStairAndDoorParts = styled.ul`
  grid-column: 7/-1;
  grid-row: 3;

  @media (width >= 500px) {
    grid-column: 4/7;
  }

  @media (width >= 768px) {
    grid-column: 3/5;
  }

  @media (width >= 900px) {
    grid-column: 4/6;
  }
`;

const ContactUs = styled.h2`
  grid-column: 1/-1;
  grid-row: 4;

  @media (width >= 768px) {
    grid-column: 8/12;
    grid-row: 1;
  }

  @media (width >= 900px) {
    grid-column: 9/12;
  }

  @media (width >= 1200px) {
    grid-column: 10/12;
  }
`;

const ContactDetails = styled.ul`
  font-size: 14px;
  grid-column: 1/-1;
  grid-row: 5;

  @media (width >= 768px) {
    grid-column: 8/-1;
    grid-row: 2;
  }

  @media (width >= 900px) {
    grid-column: 9/-1;
  }

  @media (width >= 1200px) {
    grid-column: 10/-1;
  }

  li {
    display: flex;
    gap: 1.05rem;

    span {
      align-items: center;
      display: flex;
      justify-content: center;
      width: 0.75rem;
      top: 1px;
      position: relative;
    }

    &:last-of-type {
      max-width: 18rem;

      span {
        align-items: start;
        margin-top: 0.3rem;
      }
    }
  }
`;

const socialIconsStyles = `
  column-gap: 1.75rem;
  grid-template-columns: repeat(3, 1.5rem);
  margin-bottom: 5px;

  svg {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

const DesktopSocialIcons = styled.div`
  ${socialIconsStyles}
  display: none;

  @media (width >= 768px) {
    align-items: end;
    display: grid;
    grid-column: 9/-1;
    grid-row: 3;
    justify-content: end;
    margin-bottom: 0.1875rem;
  }

  @media (width >= 1000px) {
    grid-column: 9/12;
  }
`;

const MobileSocialIcons = styled.div`
  ${socialIconsStyles}
  display: grid;
  grid-column: 1/-1;
  grid-row: 2;

  @media (width >= 768px) {
    display: none;
  }
`;

const LogoAndSmallPrint = styled.div`
  display: grid;
  grid-column: 1/-1;
  grid-row: 6/9;
  grid-template-columns: subgrid;
  row-gap: 0.8125rem;

  @media (width >= 768px) {
    grid-row: 4;
  }

  p,
  a {
    font-family: 'Open Sans', 'Segoe UI', Tahoma, sans-serif;
    font-size: 0.875rem;
  }
`;

const LogoWrapper = styled(Link)`
  grid-column: 1/3;
  grid-row: 1;
  margin-bottom: 3px;
  margin-top: 2.25rem;
  width: 9.25rem;

  @media (width >= 768px) {
    margin-top: 1.5rem;
    margin-bottom: initial;
  }

  @media (width >= 900px) {
    grid-column: 2/4;
  }
`;

const Links = styled.div`
  display: flex;
  font-style: italic;
  gap: 1.25rem;
  grid-column: 1/-1;
  grid-row: 3;

  @media (width >= 450px) {
    gap: 2.5rem;
  }

  @media (width >= 768px) {
    grid-row: 3;
    grid-column: 6/-1;
    justify-content: end;
  }

  @media (width >= 1000px) {
    grid-column: 7/12;
  }
`;

const Copyright = styled.p`
  grid-column: 1/-1;
  grid-row: 4;

  @media (width >= 768px) {
    grid-column: 1/-1;
    grid-row: 3;
  }

  @media (width >= 900px) {
    grid-column: 2/-1;
  }
`;

const WeMadeThis = styled.p`
  grid-column: 1/-1;
  grid-row: 5;
  text-align: left;

  @media (width >= 768px) {
    grid-row: 4;
    text-align: center;
  }
`;

export default Footer;
